import { useCallback, useEffect, useState } from "react";
import { updateStudentDetail } from "../../firestore/Functions/accountFunctions";
import { Textbox } from "../Common/Textbox";
import { StudentDetailView } from "../../firestore/Types/StudentDetailSchema";
import { CheckoutSesssion } from "./CheckoutSession";
import { useStudent } from "../../contexts/auth/StudentContext";
import { Badge } from "../Common/Badge";
import { useUtility } from "../../contexts/auth/UtilityContext";

export function StudentDetails() {

    const [tempStudentDetails, setTempStudentDetails] = useState<StudentDetailView>({} as StudentDetailView);

    const [customerHasSubscription, setCustomerHasSubscription] = useState(false);

    const [showBilling, setShowBilling] = useState(false);

    const [isEdited, setIsEdited] = useState(false);

    const [isSaving, setIsSaving] = useState(false);

    const { setNewToast } = useUtility();

    const { studentDetail, stripeCustomerSubscriptions, refreshStudentDetail } = useStudent();

    const setupPage = useCallback(async () => {
        if (studentDetail?.StripeCustomerId === undefined) {
            return;
        }
        setTempStudentDetails(studentDetail);
        if (stripeCustomerSubscriptions && stripeCustomerSubscriptions.length !== 0) {
            setCustomerHasSubscription(true);
        } else {
            setCustomerHasSubscription(false);
        }
    }, [studentDetail, stripeCustomerSubscriptions]);

    const getRowSpan = () => {
        return showBilling ? "row-span-3" : "row-span-1";
    }

    const handleChangeUserDetailValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setTempStudentDetails((prevState) => {
            return {
                ...prevState,
                [name]: value
            }
        });
    }

    const handleCancelChanges = () => {
        setTempStudentDetails(studentDetail);
    }

    const handleSaveChanges = async () => {
        setIsSaving(true);
        await updateStudentDetail(tempStudentDetails).catch((error) => {
            setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
        });
        await refreshStudentDetail().catch((error) => {
            setNewToast({title: "Internal Error", message: error.message, toastType: "error"})
        });
        setIsSaving(false);
    }

    useEffect(() => {
        setupPage();
    }, [setupPage]);

    useEffect(() => {
        if (studentDetail.PreferedContactEmail !== tempStudentDetails.PreferedContactEmail || studentDetail.PreferedContactPhone !== tempStudentDetails.PreferedContactPhone) {
            setIsEdited(true);
        } else {
            setIsEdited(false);
        }
    }, [tempStudentDetails, studentDetail]);
    
    return (
        <>
            <div className={"section-box p-4 flex flex-col gap-4 " + getRowSpan()}>
                <div className="flex flex-row mb-2 w-full">
                    <h3 className="section-title w-full">Billing information</h3>
                    <div className="m-2">
                        <ShowBillingBadge stripeCustomerSubscriptions={customerHasSubscription}/>
                    </div>
                    {showBilling ? <button className="primary-button ml-6" onClick={() => setShowBilling(false)}>Hide</button> : <button className="primary-button ml-6" onClick={() => setShowBilling(true)}>Edit</button>}
                </div>
                {showBilling && <div className="m-4 rounded-md border border-gray-300 p-4">
                    <CheckoutSesssion/>
                </div>}
            </div>
            <div className="section-box p-4 gap-4">
                <div className="flex flex-row">
                    <h3 className="section-title ">Preferred Contact Information</h3>
                </div>
                <div className="grid">
                    <Textbox label="Email" name={"PreferedContactEmail"} value={tempStudentDetails.PreferedContactEmail ?? ""} onValueChange={handleChangeUserDetailValue}/>
                    <Textbox label="Phone" name={"PreferedContactPhone"} value={tempStudentDetails.PreferedContactPhone ?? ""} onValueChange={handleChangeUserDetailValue}/>
                </div>
                {isEdited && 
                    <div className="flex flex-row justify-end gap-4">
                        {isSaving && <p>Saving...</p>}
                        <button className="primary-button" onClick={handleSaveChanges}>Save</button>
                        <button className="primary-button" onClick={handleCancelChanges}>Cancel</button>
                    </div>}
            </div>
        </>
    )

}

function ShowBillingBadge({ stripeCustomerSubscriptions }: { stripeCustomerSubscriptions: boolean }) {
    console.log(stripeCustomerSubscriptions);
    if (stripeCustomerSubscriptions === true) {
        return <Badge label="Completed" color="green" />;
    }

    return <></>
}